import Shop from './components/shop';
import Checkout from './components/checkout';
import Payment from './components/payment';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

function App() {
  return (
        <Router>
            <Routes>
                <Route path='/checkout' element={<Checkout/>}/>
                <Route path='/payment' element={<Payment/>}/>
                <Route path='/shop' element={<Shop/>}/>
                <Route path='/' element={<Shop/>}/>
            </Routes>
        </Router>
  );
}

export default App;
